import React from "react";
import downloadScreen from "../assets/images/Mobile-Screen.png";
import googlePlayStore from "../assets/images/Google-Play-Store.png";
import applerPlayStore from "../assets/images/Apple-Play-Store.png";

const Downloads = () => {
  return (
    <div className="w-full md:w-981 flex justify-center h-auto md:h-100 bg-[#eeeeee]">
      <div className="downloads-container flex flex-col md:flex-row justify-center items-center">
        <div className="p-5 md:p-10 mr-0 md:mr-20">
          <img
            src={downloadScreen}
            alt="Shadow"
            width={260}
            className="h-[450px]"
          />
        </div>
        <div className="text-center md:text-left pb-4 sm:pb-8 download-text">
          <h2 className="text-lg font-extrabold">
          <span className="font-bold text-4xl download-text">Download </span>
          <span className="font-bold text-[#E53A36] text-4xl download-text">S</span>
          <span className="font-bold text-4xl download-text">mart</span>
          <span className="font-bold text-[#E53A36] text-4xl download-text">S</span>
          <span className="font-bold text-4xl download-text">pend</span>
          </h2>

          {/* Google Play logo */}
          {/* <div className="mt-4 flex justify-center md:justify-start">
            <img
              src={googlePlayLogo}
              alt="Google Play"
              className="w-[200px] md:w-[250px]"
            />
          </div> */}

          <div
          className="flex mt-4 justify-center sm:justify-start"
        >
          <div className="inline-block mr-2">
            <a
            href="https://play.google.com/store/apps/details?id=sstech.com.smartspend"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={googlePlayStore}
                alt="Google Play Store"
                className="h-[35px] w-[120px] sm:h-[55px] sm:w-[170px]"
              />
            </a>
          </div>
        {/*  <div className="inline-block">
            <a
              href="https://apps.apple.com/in/app/wallet-income-expense-tracker/id1445995357"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={applerPlayStore}
                alt="Apple App Store"
                className="h-[35px] w-[120px] sm:h-[55px] sm:w-[170px]"
              />
            </a>
          </div>*/}
        </div>
        </div>
      </div>
    </div>
  );
};

export default Downloads;
